import { action, flow, makeObservable, observable } from "mobx";
import { rendermixAPI } from "@api/main";
import { analytics } from "../services/analytics";

const ALLOWED_COUNTRIES = ["IN"];

export default class GeoBlockStore {
  isBlocked: boolean = false;
  isChecking: boolean = true;

  constructor() {
    makeObservable(this, {
      isBlocked: observable,
      isChecking: observable,
      checkLocation: flow,
      setBlocked: action,
    });
  }

  setBlocked(val: boolean) {
    this.isBlocked = val;
  }

  *checkLocation() {
    try {
      const location: Awaited<ReturnType<typeof rendermixAPI.getCurrentLocation>> = yield rendermixAPI.getCurrentLocation();
      this.isBlocked = !ALLOWED_COUNTRIES.includes(location.countryCode);
      if (this.isBlocked) {
        // WEB-4038 geo wall replaced the app — record the lost visit.
        analytics.track("geo_blocked", { country: location.countryCode });
      }
    } catch {
      this.isBlocked = false;
    } finally {
      this.isChecking = false;
    }
  }
}
